<template>
  <tbody>
    <template v-if="totalRows > 0">
      <tr v-for="(row, index) in rows" :key="`${metric}:${row.label}`">
        <td v-if="displayDate && index === 0" class="border px-4 py-2" :rowspan="totalRows">
          {{ endDate }}
        </td>
        <td class="border px-4 py-2">
          {{ row.label }}
        </td>
        <td class="border px-4 py-2 text-right">
          {{ row.value }}
        </td>
      </tr>
    </template>
    <template v-else>
      <tr>
        <td class="border px-4 py-2 text-teal-900 text-center" colspan="3">
          No insights available for {{ endTime }}
        </td>
      </tr>
    </template>
  </tbody>
</template>

<script>
import moment from 'moment';
import { orderBy } from 'lodash-es';

export default {
  props: {
    metric: {
      type: String,
      required: true,
    },
    displayDate: Boolean,
    insights: {
      type: Object,
      required: true,
    },
  },
  computed: {
    endTime() {
      return moment(this.insights.end_time).format('DD/MM/YYYY');
    },
    rows() {
      return orderBy(
        Object.keys(this.insights.value).map((key) => ({
          label: key,
          value: this.insights.value[key],
        })),
        ['value'],
        ['desc']
      );
    },
    totalRows() {
      return this.rows.length;
    },
  },
};
</script>
